module.exports = "<my-sale-display my-sale=\"$$sale.data.mySale\">\n</my-sale-display>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/scrapping/sale/templates/details.html
// module id = 1621
// module chunks = 0